module.exports = __webpack_public_path__ + "img/modelo_carga_profesores.7caa7aa3.png";